// extracted by mini-css-extract-plugin
export var closeButton = "_1o-3";
export var header = "_1o-0";
export var link = "_1o-1";
export var retryButton = "_1o-2";